import React from 'react';
import { Link as MUILink, LinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export type ExtendedLinkProps = LinkProps & {
    to: string;
    as?: string;
    children: React.ReactNode | string | undefined;
};

const Link = (props: ExtendedLinkProps) => {
    return (
        <MUILink {...props} component={RouterLink} to={props.to}>
            {props.children}
        </MUILink>
    );
};

export default Link;
